import { AbstractControl, ValidatorFn } from "@angular/forms";
import { instanceOfSelectListOptionWithValue } from "@shared/components/form-fields/select-list-option";

export function requireTypeaheadSelectionWithValue<T>(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value == null || control.value == '' || (control.value != null && instanceOfSelectListOptionWithValue<T>(control.value))
      ? null 
      : { 'requiredSelection' : 'Please select from the list'};
  };
}

export function requireTypeaheadSelection(): ValidatorFn {
  return requireTypeaheadSelectionWithValue<string>();
}